import {
  GetCreditNotesResponseSchema,
  type GetCreditNotesResponse,
} from '@vy/api-definition';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { queryKeys } from '../../services/query-key/query-keys';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';

export function useCreditNotes(
  customerId: string,
  options?: CustomUseQueryOptions<GetCreditNotesResponse>,
) {
  return useQuery(
    queryKeys.creditNotes(customerId),
    async () => {
      const api = getPrivateApi();
      const creditNotes = await api.getCreditNotes({ customerId });

      return GetCreditNotesResponseSchema.parse(creditNotes);
    },
    options,
  );
}
